import { HelpTextConfig } from './helptext-config';

export const testPageHelpText: Record<string, HelpTextConfig> = {
  skillTimeout: {
    title: "Skill Timeout",
    content: "Maximum time in seconds allowed for skill execution. The system will consider the skill to have timed out if a response is not received in this time.",
  },

  annotation: {
    title: "Annotation",
    content: "Technical documentation and usage examples for the skill."
  },

  testMode: {
    title: "Test Mode",
    content: "When enabled, the endpoint is called with the URL parameter \"test_mode=true\". This should prevent any write action if the skill has been correctly implemented."
  },

  inputParameters: {
    title: "Input Parameters",
    content: "Configure the input values that will be sent to your skill in the body of the request. Reference the annotation to better understand the expected input parameters."
  },

  results: {
    title: "Response",
    content: "The response returned by your skill."
  }
};